package ui.device.detail

data class DeviceArgs(var deviceId: Long = -1)